
import httpClienteToken from '../../services/HttpClientToken';

import { HttpResponse } from '../../interfaces/auth/AuthInterface';

import { ConsultaCubiculosParams, CubiculosProps, LiberarCubiculoParams, ObtenerCubiculoParams, OcuparCubiculoResponse } from '../../interfaces/comun/CubiculosInterface';

export const ConsultaCubiculos = () => {

    return new Promise<CubiculosProps[]>((resolve, reject) => {
        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            httpClienteToken.post('/Api/Cubiculo/ConsultaCubiculos', null, token)
                .then(({ data }: { data: CubiculosProps[] }) => {
                    resolve(data);
                })
                .catch(() => {
                    resolve([]);
                });

        } else {
            resolve([]);
        }
    });

};

export const ConsultaCubiculosFiltros = (params: ConsultaCubiculosParams) => {

    return new Promise<CubiculosProps[]>((resolve, reject) => {
        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {

            const { token } = data;

            httpClienteToken.post('/Api/Cubiculo/ConsultaCubiculosFiltros', params, token)
                .then(({ data }: { data: CubiculosProps[] }) => {
                    resolve(data);
                })
                .catch(() => {
                    resolve([]);
                });
        } else {
            resolve([]);
        }
    });

};

export const OcuparCubiculo = (params: ObtenerCubiculoParams) => {

    return new Promise<OcuparCubiculoResponse>((resolve, reject) => {
        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            httpClienteToken.post('/Api/Cubiculo/OcuparCubiculo', params, token)
                .then(({ data }: { data: OcuparCubiculoResponse }) => {
                    resolve(data);
                })
                .catch(() => {
                    resolve({
                        success: false,
                        message: '',
                        idTipoCubiculo: 0,
                        numeroCubiculo: 0,
                        usuario: '',
                        idEstatus: 0,
                        estatus: '',
                        idUnidad: 0,
                        unidad: '',
                        liberar: false,
                    });
                });
        } else {
            resolve({
                success: false,
                message: '',
                idTipoCubiculo: 0,
                numeroCubiculo: 0,
                usuario: '',
                idEstatus: 0,
                estatus: '',
                idUnidad: 0,
                unidad: '',
                liberar: false,
            });
        }
    });
};

export const LiberarCubiculo = (params: LiberarCubiculoParams) => {

    return new Promise<HttpResponse>((resolve, reject) => {
        const data = JSON.parse(window.localStorage.getItem('data') ?? '');

        if (data) {
            const { token } = data;

            httpClienteToken.post('/Api/Cubiculo/LiberarCubiculo', params, token)
                .then(({ data }: { data: HttpResponse }) => {
                    resolve(data);
                })
                .catch(() => {
                    resolve({ success: false, message: '', });
                });
        } else {
            resolve({ success: false, message: '', });
        }
    });
};




